import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution, trackMarketingEvent } from "@/lib/marketingAnalytics";

export default function MarketingTracker() {
  const location = useLocation();

  useEffect(() => {
    captureAttribution();
    trackMarketingEvent("page_view", {
      page_title: document.title,
      search: location.search || undefined,
    });
  }, [location.pathname, location.search]);

  return null;
}
